// const Qs = require('qs')
class HttpUtil {
	constructor() {

	}
	request(params) {
		params.isnologin = params.isnologin || false;
		let token = window.localStorage.getItem('token');
		if (!token && !params.isnologin) {
			params.that.$router.push({
				path: '/login'
			})
		} else {
			let url = params.url;
			let data = params.data;
			let method = params.method || 'POST';
			// console.log(url+"="+method);
			let args = {
				method: method,
				url: url,
				data: data,
				// data:Qs.stringify(data),
				headers: params.headers ? params.headers : {
					// 'Content-Type':'application/json;charset=UTF-8',
					// 'Content-Type':'application/x-www-form-urlencoded',
					Authorization: token
					// 'token': token
				},
			}
			if (params.responseType) {
				args.responseType = params.responseType;
			}
			params.that.$axios.defaults.headers.post['Content-Type'] = params.headers ? params.headers['Content-Type'] : params.that.$axios.defaults.headers.post['Content-Type']
			params.that.$axios(args).then(response => {
				// console.log({response,responseType:params.responseType})
				if (params.responseType) {
					params.cb(response);
				} else if (response.code == 1009) {
					// params.that.$router.push({path:'/'})
				} else if (response.data.result == '11202') {
					params.that.$router.push({
						path: '/login'
					})
				} else {
					params.cb(response.data);
				}

			}).catch(error => {
				console.log(error)
			})
		}
	}

	requestraw(params) {
		$.ajax({
		    beforeSend: function (XMLHttpRequest) {
		        XMLHttpRequest.setRequestHeader("Authorization",localStorage.getItem("token"));
		    },
		    type:"POST",
		    crossDomain: true,
		    url:params.url,
		    contentType:"application/json",
		    data:JSON.stringify(params.data),
		    dataType:"json",
		    xhrFields: {
		    	'Access-Control-Allow-Origin': '*'
		    },
		    success:function(msg){
					params.cb(msg);
		    },
		    error:function (msg)
		    {
		    }
		});
	}

}
export default new HttpUtil()
